// Shared account-management types. Mirrors the API allowlist entry
// (apps/api/src/auth/allowlist.ts): the email is the Google identity, the role
// gates access, and addedBy/addedAt record who first granted it (the "Created
// by" column — preserved across role edits, AC5).
// The Role union is single-sourced in @bbbk/schema (the allowlist tiers); User
// wraps it with the allowlist-only addedBy/addedAt fields (not a wire type).
import type { AllowlistRole, Role } from '@bbbk/schema';
export type { AllowlistRole, Role };

export type User = {
  email: string;
  // AllowlistRole, not Role: since household-app-access a KV entry may say
  // `customer`, and the list endpoint sends every entry. Typing this as the
  // four desk roles let a customer through as an impossible value — counted
  // as NaN, drawn with no pill style, invisible in the chips.
  role: AllowlistRole;
  addedBy?: string;
  addedAt?: string;
};

// The minimal identity the activity tabs share (feed rail, heatmap rows): who +
// their allowlist role. A projection of User so the shape can't drift.
export type Person = Pick<User, 'email' | 'role'>;

export const ROLES: Role[] = ['admin', 'owner', 'helper', 'staff'];

export const ROLE_BLURB: Record<Role, string> = {
  admin: 'Manages who can sign in',
  owner: 'Full access to the kennel',
  helper: 'Day-to-day access',
  staff: 'Sees only their own shifts',
};

// The FILTER offers every role the allowlist can hold; the PICKER (ROLES) offers
// only the four an admin may grant. A customer is minted by a registration link
// and must never be a dropdown choice (R-ACC-3).
export const FILTER_ROLES: AllowlistRole[] = [...ROLES, 'customer'];

export type RoleFilter = 'all' | AllowlistRole;
